import { render, staticRenderFns } from "./NaverAd.vue?vue&type=template&id=a57bad68"
import script from "./NaverAd.vue?vue&type=script&lang=js"
export * from "./NaverAd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports